module.exports = __webpack_public_path__ + "static/head-logo-a0003db5115ddaa0ae388a5eb4eb1c65.png";